export default function MySQL_ASCII() {
  return (
    <div>
      <h2>MySQL_ASCII</h2>    </div>
  );
}